/**
 * Domain filter pills for the explorer section
 */

import React from 'react'
import { X } from 'lucide-react'

interface DomainPillsProps {
  domains: { domain: string; count: number }[]
  selectedDomain: string | null
  onSelect: (domain: string | null) => void
  totalCount: number
}

export const DomainPills: React.FC<DomainPillsProps> = ({
  domains,
  selectedDomain,
  onSelect,
  totalCount,
}) => {
  const formatDomain = (domain: string) => {
    return domain.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  }

  return (
    <div className="flex flex-wrap gap-2">
      {/* All button */}
      <button
        onClick={() => onSelect(null)}
        className={`px-3 py-1.5 rounded-full text-sm transition-colors ${
          selectedDomain === null
            ? 'bg-accent text-white'
            : 'bg-secondary text-primary hover:bg-tertiary'
        }`}
      >
        All ({totalCount})
      </button>

      {/* Domain pills */}
      {domains.map(({ domain, count }) => (
        <button
          key={domain}
          onClick={() => onSelect(selectedDomain === domain ? null : domain)}
          className={`px-3 py-1.5 rounded-full text-sm transition-colors flex items-center gap-1 ${
            selectedDomain === domain
              ? 'bg-accent text-white'
              : 'bg-secondary text-primary hover:bg-tertiary'
          }`}
        >
          {formatDomain(domain)} ({count})
          {selectedDomain === domain && (
            <X className="w-3 h-3" />
          )}
        </button>
      ))}
    </div>
  )
}

export default DomainPills
